<!-- 政务通用标题组件 特殊组件-->
<template>
  <div
    class="slot-body"
    :class="[notFlex ? 'not-flex' : '']"
    :style="{ width: renderVw(width) + 'vw' }"
  >
    <div
      :class="[
        'slot-header',
        special ? 'special-header' : '',
        backgroundImageSize,
      ]"
      :style="noHeaderMargin ? `margin: 0` : null"
    >
      <div class="slot-title" :data-content="title" :class="{'slot-title-special': slotTitleSpecial}">
        {{ title }}
        <span
          v-if="titleSuffix && titleSuffix != ''"
          class="slot-title-suffix"
          >{{ titleSuffix }}</span
        >
      </div>
    </div>
    <div
      :class="['slot-content', special ? 'special-body' : '']"
      :style="{ height: renderVh(contentHeight) + 'vh' }"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "TitleSlot",
  mixins: [],
  props: {
    title: {
      type: String,
      default: "标题",
    },
    titleSuffix: {
      type: String,
      default: "",
    },
    special: {
      type: Boolean,
      default: false,
    },
    slotTitleSpecial: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 466,
    },
    contentHeight: {
      type: [String, Number],
      default: null,
    },
    noHeaderMargin: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Number,
      default: null,
    },
    /** 是否不撑开页面剩余高度 */
    notFlex: {
      type: Boolean,
      default: false,
    },
    backgroundImageSize: {
      type: String,
      default: "header-img-466",
    },
  },
  methods: {
    renderVh($px) {
      if ($px) {
        return ($px / 1080) * 100;
      }
    },
    renderVw($px) {
      if ($px) {
        return ($px / 1920) * 100;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@font-face {
  font-family: "YouSheBiaoTiHei"; /* 自定义字体名称 */
  src: url("../../../assets/fonts/YOUSHEBIAOTIHEI-2.ttf") format("truetype"); /* 路径和格式 */
}
@function vw($px) {
  @return ($px / 1920) * 100vw;
}

@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.slot-body {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1;
  &.not-flex {
    flex: none;
  }
  .slot-header {
    position: relative;
    width: 100%;
    height: vh(65);
    margin-bottom: vh(16);
    margin-bottom: 10px;
    background-image: url("../../../assets/images/governmentAffairs/common/tittle_bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
    .slot-title {
      position: absolute;
      top: vh(31);
      left: vw(34);
      line-height: vh(17);
      padding-right: vw(8);
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      font-size: fontSize(24);
      color: #ffffff;
      font-style: italic;
      background: linear-gradient(0deg, #5fde8c 0%, #ffffff 89.7705078125%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      .slot-title-suffix {
        font-size: fontSize(16);
        margin-left: vw(-14);
      }
    }
    .slot-title-special {
      top: vh(28);
    }
    .slot-title::before {
      content: attr(data-content);
      position: absolute;
      top: 0;
      left: 0;
      color: transparent;
    }
  }
  .header-img-334 {
    background-image: url("../../../assets/images/governmentAffairs/common/pic_name_sd.png");
  }
  .header-img-466 {
    background-image: url("../../../assets/images/governmentAffairs/common/tittle_bg.png");
  }
  .header-img-489 {
    background-image: url("../../../assets/images/governmentAffairs/common/tittle_bg_l.png");
  }
  .header-img-668 {
    background-image: url("../../../assets/images/governmentAffairs/common/pic_name_ll.png");
  }
  .special-header {
    height: vh(34);
    background: linear-gradient(
      45deg,
      rgba(13, 255, 166, 0.1) 0%,
      rgba(0, 142, 90, 0.1) 100%
    );
    .slot-title {
      position: absolute;
      top: vh(10);
      left: vw(14);
      padding-right: vw(10);
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      font-size: fontSize(24);
      color: #ffffff;
      font-style: italic;
      background: linear-gradient(0deg, #5fde8c 0%, #ffffff 89.7705078125%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .slot-content {
    width: 100%;
    display: flex;
    // height: calc(100% - 50px);
    // flex: 1;
  }
  .special-body {
    width: 100%;
    background: linear-gradient(
      45deg,
      rgba(13, 255, 166, 0.1) 0%,
      rgba(0, 142, 90, 0.1) 100%
    );
  }
}
</style>
